import { Box, useMultiStyleConfig, type BoxProps } from '@chakra-ui/react';
import { type ReactNode } from 'react';
import {
  StatusCardRootContext,
  StatusCardVariant
} from './status-card-context';

export interface StatusCardRootProps extends BoxProps {
  variant: StatusCardVariant;
}

export function StatusCardRoot({
  variant,
  children,
  ...props
}: StatusCardRootProps): ReactNode {
  const styles = useMultiStyleConfig('StatusCard', { variant });

  return (
    <StatusCardRootContext.Provider value={{ variant }}>
      <Box __css={styles.root} {...props}>
        {children}
      </Box>
    </StatusCardRootContext.Provider>
  );
}
